import { createProvider } from '@frontend/store';
import { PX_PER_MINUTE } from '../constants';

const DEFAULT_ZOOM_LEVELS = [1, 2];
export const DEFAULT_ZOOM_LEVEL = 1;

type State = {
  zoomEnabled: boolean;
  showControls: boolean;
  zoomLevel: number;
  zoomLevels: number[];
  pxPerMinute: number;
  canZoomIn: boolean;
  canZoomOut: boolean;
  onZoomLevelChange?: (level: number) => void;
};

type Actions = {
  zoomIn: () => void;
  zoomOut: () => void;
};

export type ZoomStore = State & Actions;

const computeZoomDerived = (level: number, levels: number[]) => ({
  canZoomIn: level > levels[0],
  canZoomOut: level < levels[levels.length - 1],
  pxPerMinute: Math.round(PX_PER_MINUTE * level),
});

export const {
  Provider: ZoomStoreProvider,
  useStore: useZoomStore,
  useNonReactiveStore: useNonReactiveZoomStore,
} = createProvider<ZoomStore>()((set, get) => ({
  zoomEnabled: false,
  showControls: false,
  zoomLevel: DEFAULT_ZOOM_LEVEL,
  zoomLevels: DEFAULT_ZOOM_LEVELS,
  pxPerMinute: PX_PER_MINUTE,
  canZoomIn: false,
  canZoomOut: true,

  zoomIn: () => {
    const { zoomLevel, zoomLevels, onZoomLevelChange } = get();
    const currentIndex = zoomLevels.findIndex((l) => l >= zoomLevel);
    if (currentIndex <= 0) return;
    const nextLevel = zoomLevels[currentIndex - 1];
    if (onZoomLevelChange) {
      onZoomLevelChange(nextLevel);
    } else {
      set({ zoomLevel: nextLevel, ...computeZoomDerived(nextLevel, zoomLevels) });
    }
  },
  zoomOut: () => {
    const { zoomLevel, zoomLevels, onZoomLevelChange } = get();
    const currentIndex = zoomLevels.findIndex((l) => l >= zoomLevel);
    if (currentIndex >= zoomLevels.length - 1) return;
    const nextLevel = zoomLevels[currentIndex + 1];
    if (onZoomLevelChange) {
      onZoomLevelChange(nextLevel);
    } else {
      set({ zoomLevel: nextLevel, ...computeZoomDerived(nextLevel, zoomLevels) });
    }
  },
}));
